import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background: ${CSSVars.gray50};
  padding: 70px 20px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 90px 30px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 110px 40px;
  }

  .inner {
    max-width: 1240px;
    margin: 0 auto;
  }

  header {
    text-align: center;
    margin-bottom: 40px;
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 30px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: ${CSSVars.black};
    margin: 0 auto 12px;
    max-width: 720px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 40px;
    }
  }

  header p {
    font-family: ${CSSVars.secondaryFont};
    font-weight: 300;
    font-size: 16px;
    line-height: 1.6;
    color: ${CSSVars.gray600};
    margin: 0 auto;
    max-width: 620px;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
    list-style: none;
    padding: 0;
    margin: 0;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .plan {
    background: ${CSSVars.white};
    border: 1px solid ${CSSVars.gray200};
    border-radius: 14px;
    padding: 22px 22px 24px;
    display: flex;
    flex-direction: column;
  }

  .plan.featured {
    border-color: ${CSSVars.blue500};
    box-shadow: 0 18px 40px -28px rgba(76, 79, 255, 0.6);
  }

  .plan .badge {
    align-self: flex-start;
    font-family: ${CSSVars.secondaryFont};
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${CSSVars.blue600};
    background: ${CSSVars.blue50};
    border-radius: 100px;
    padding: 4px 10px;
    margin-bottom: 12px;
  }

  .plan .tier {
    font-family: ${CSSVars.primaryFont};
    font-weight: 600;
    font-size: 17px;
    color: ${CSSVars.black};
    margin: 0 0 6px;
  }

  .plan .price {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 32px;
    letter-spacing: -0.02em;
    color: ${CSSVars.black};
    line-height: 1;
    margin: 0 0 4px;
  }

  .plan .price small {
    font-size: 14px;
    font-weight: 400;
    color: ${CSSVars.gray500};
  }

  .plan .headline {
    font-family: ${CSSVars.secondaryFont};
    font-size: 14px;
    font-weight: 600;
    color: ${CSSVars.blue600};
    margin: 14px 0 12px;
    padding-top: 14px;
    border-top: 1px solid ${CSSVars.gray100};
  }

  .plan ul {
    list-style: none;
    padding: 0;
    margin: 0 0 20px;
    display: flex;
    flex-direction: column;
    gap: 7px;
    flex: 1;
  }

  .plan li {
    font-family: ${CSSVars.secondaryFont};
    font-size: 14px;
    line-height: 1.45;
    color: ${CSSVars.gray700};
    padding-left: 20px;
    position: relative;
  }

  .plan li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 7px;
    width: 10px;
    height: 6px;
    border-left: 2px solid ${CSSVars.blue500};
    border-bottom: 2px solid ${CSSVars.blue500};
    transform: rotate(-45deg);
  }

  .plan a {
    font-family: ${CSSVars.secondaryFont};
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
    border-radius: 100px;
    padding: 11px 18px;
    color: ${CSSVars.blue600};
    border: 1px solid ${CSSVars.gray300};
    transition: border-color 0.15s ease;
  }

  .plan a:hover {
    border-color: ${CSSVars.blue500};
  }

  .plan.featured a {
    background: ${CSSVars.blue500};
    border-color: ${CSSVars.blue500};
    color: ${CSSVars.white};
  }

  .plan.featured a:hover {
    background: ${CSSVars.blue600};
  }

  .footnote {
    font-family: ${CSSVars.secondaryFont};
    font-size: 13px;
    color: ${CSSVars.gray500};
    text-align: center;
    margin: 24px auto 0;
    max-width: 620px;
  }
`;
